// js/phone-input.js
// Initialises intl-tel-input on every cell_phone, other_phone, and phone input across admin, dashboard, registration, and the offer claim form.
// intl-tel-input is loaded via CDN script tag (see layout.php) and exposed as window.intlTelInput.

/**
 * Attach intl-tel-input to all cell_phone, other_phone, and phone inputs on the page.
 * Called once after DOMContentLoaded.
 */
export function initPhoneInputs() {
    if (typeof window.intlTelInput === 'undefined') return;

    document.querySelectorAll('input[name="cell_phone"], input[name="other_phone"], input[name="phone"]').forEach(input => {
        const iti = window.intlTelInput(input, {
            initialCountry: 'us',
            preferCountries: ['us', 'ca', 'mx', 'gb', 'au'],
            nationalMode: true,   // display without country code in the field
            formatOnDisplay: true,
            separateDialCode: true,
        });

        // Before the enclosing form submits, replace the input value with
        // the full international number (e.g. "+1 (555) 555-5555") so the
        // country code is persisted.  If the field is empty, leave it alone.
        const form = input.closest('form');
        if (form) {
            form.addEventListener('submit', () => {
                const number = iti.getNumber();
                if (number) {
                    input.value = number;
                }
            }, { capture: true });

            // #937: keep the phone flag in sync with the shipping Country
            // select. Each <option> in country-select.php carries a
            // `data-iso2` attribute (already lowercase, e.g. "gb") — read it
            // off the currently selected option and hand it to
            // intl-tel-input, which expects a lowercase ISO2 code.
            // .toLowerCase() below is defensive (a no-op today) in case that
            // ever changes.
            syncPhoneCountryToShippingCountry(form, iti);
        }
    });
}

/**
 * Wire a country <select> (rendered by Views/Partials/country-select.php)
 * inside `form` to update `iti`'s selected country flag whenever the
 * visitor changes it. Bails silently if the form has no such select or the
 * selected option is missing a `data-iso2` value (e.g. the placeholder
 * "Select Country" option) — the phone flag simply stays as-is in that case.
 */
function syncPhoneCountryToShippingCountry(form, iti) {
    const countrySelect = form.querySelector('select[name="country"]');
    if (!countrySelect) return;

    const syncCountry = () => {
        const option = countrySelect.options[countrySelect.selectedIndex];
        const iso2 = option ? option.getAttribute('data-iso2') : null;
        if (iso2) {
            iti.setCountry(iso2.toLowerCase());
        }
    };

    countrySelect.addEventListener('change', syncCountry);
}
